<template>
  <div class="devauthss" align="center" style="width:80%">
    <el-collapse v-model="activeNames" >
      <el-collapse-item title="版本号:    1.1 " name="1"></el-collapse-item>
      <el-collapse-item title="时间:      2020-2022 " name="2"></el-collapse-item>
      <el-collapse-item title="开发者:    Dansl " name="3"></el-collapse-item>
      <el-collapse-item title="备注:      定制项目开发  " name="4"></el-collapse-item>
      <el-collapse-item title="联系地址:  北京市昌平区 " name="5"></el-collapse-item>
    </el-collapse>
    <el-divider></el-divider>
    <div slot="footer" align="center">
      <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
            <a  href="/">{{$t('navBar.goback')}}</a> 
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>   
  </div> 
</template>

<script>
export default {
  methods: {

  },
};
</script>

<style scoped>
.devauthss{
  padding: 24px 56px;
  margin:0 auto;
}
</style>
